import {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import {
  getDynamicFormTabs,
  getInterfaceId,
} from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";
import { Form, Tabs } from "antd";
import "../../Components/DynamicForm/DynamicForm.css";
import DynamicFormComponent from "../../Components/DynamicForm/DynamicForm";
import { API } from "../../Axios/Axios";
import DynamicReport from "../../Components/DynamicReport/DynamicReport";
import Title from "antd/es/typography/Title";
import AccessDenied from "../AccessDenied/AccessDenied";
import { useAuthStore } from "../../AuthStore/AuthStore";
import DynamicMaster from "../../Components/DynamicMaster/DynamicMaster";

const { TabPane } = Tabs;
const InterfaceComponent = forwardRef(({ ...props }, ref) => {
  const location = useLocation();
  const { state } = location || {};
  const [formData, setFormData] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<any>(null);
  const [form] = Form.useForm();
  const [actionType] = useState(state?.actionType ?? props?.actionType);
  const [activeTabId, setActiveTabId] = useState<any>(null);
  const [RId] = useState(state?.RId ?? props?.RId);
  const [interfaceId, setInterfaceId] = useState<any>(null);
  const [accessDenied, setAccessDenied] = useState<boolean>(false);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { commonContextParams } = useAuthStore();
  const dynamicFormRef = useRef();

  useEffect(() => {
    if (!props?.InterfaceName && !state.InterfaceName) {
      return;
    }
    if (props?.InterfaceName ?? state?.InterfaceName)
      getInterfaceIdBasedOnName();
  }, [props?.InterfaceName, state?.InterfaceName]);

  const getInterfaceIdBasedOnName = async () => {
    try {
      let interfaceResponse = await API.post(getInterfaceId, {
        InterfaceName: props?.InterfaceName ?? state?.InterfaceName,
      });

      if (interfaceResponse.data.message != "OK")
        throw new Error("No InterfaceId Found");

      setInterfaceId(interfaceResponse.data.data);
    } catch (error) {
      console.error("Error getting interfaceId:", error);
    }
  };

  useEffect(() => {
    setFormData([]);
    if (interfaceId) getFormTabsConfig();
  }, [interfaceId]);

  // useEffect(() => {
  //   console.log("Form Mounted:", form.getFieldsValue());
  //   //form.setFieldsValue({ ["Initiator"]: "D" });
  //   dynamicFormRef?.current?.hideField("Initiator");

  // }, []);

  useImperativeHandle(ref, () => ({
    hideTabs: (TabsName: string[]) => {
      console.log("hide Tabs called");
      console.log(TabsName);
      console.log(formData);
      if (
        formData.data.some((x: { TabName: string }) =>
          TabsName.includes(x.TabName),
        )
      ) {
        let tabsList = formData;
        let updatedList = tabsList.data.map(
          (tab: { AdditionalDetails: any; TabName: string }) => {
            if (TabsName.includes(tab.TabName)) {
              return {
                ...tab,
                AdditionalDetails: {
                  ...tab.AdditionalDetails,
                  OnLoad: false,
                  IsDefault: false,
                },
              };
            }
            return tab;
          },
        );

        let updatedFormData = {
          data: updatedList,
        };
        setFormData(updatedFormData);
      }
    },
    showTabs: (TabsName: string[]) => {
      console.log("show Tabs called");
      console.log(TabsName);
      console.log(formData);
      if (
        formData.data.some((x: { TabName: string }) =>
          TabsName.includes(x.TabName),
        )
      ) {
        let tabsList = formData;
        let updatedList = tabsList.data.map(
          (tab: { AdditionalDetails: any; TabName: string }) => {
            if (TabsName.includes(tab.TabName)) {
              return {
                ...tab,
                AdditionalDetails: {
                  ...tab.AdditionalDetails,
                  OnLoad: true,
                },
              };
            }
            return tab;
          },
        );

        let updatedFormData = {
          data: updatedList,
        };
        setFormData(updatedFormData);
      }
    },
    setNextTabAsActive: () => {
      console.log(formData);

      let currentTab = formData.data.find(
        (x: { TabId: any; TabName: string }) =>
          x.TabId.toString() === activeTabId.toString(),
      );

      if (currentTab) {
        let NextTabId = 0;
        let NextTabIndex = 0;
        let nextTab = formData.data.find(
          (x: { TabSequence: number }) =>
            x.TabSequence > currentTab.TabSequence,
        );
        NextTabId = nextTab.TabId;
        NextTabIndex = formData.data.findIndex(
          (x: { TabSequence: number }) =>
            x.TabSequence > currentTab.TabSequence,
        );
        setActiveTabId(NextTabId.toString());
        setActiveTab(NextTabIndex.toString());
      }
    },
    hideField: (fieldName: any) => {
      dynamicFormRef?.current?.hideField(fieldName);
    },
    showField: (fieldName: any) => {
      dynamicFormRef?.current?.showField(fieldName);
    },
    hideFields: (fieldName: any) => {
      dynamicFormRef?.current?.hideFields(fieldName);
    },
    showFields: (fieldName: any) => {
      dynamicFormRef?.current?.showFields(fieldName);
    },
    setValue: (fieldName: any, value: any) => {
      dynamicFormRef?.current?.setValue(fieldName, value);

      // console.log("All current fields:", form.getFieldsValue());
      // form.setFieldsValue({ [fieldName]: value });
      // form.validateFields([fieldName]).catch(() => {});
      // console.log("After setting:", form.getFieldsValue());
    },
    disableField: (fieldName: any) => {
      dynamicFormRef?.current?.disableField(fieldName);
    },
    enableField: (fieldName: any) => {
      dynamicFormRef?.current?.enableField(fieldName);
    },
    disableFields: (fieldName: Array<string>) => {
      dynamicFormRef?.current?.disableFields(fieldName);
    },
    enableFields: (fieldName: Array<string>) => {
      dynamicFormRef?.current?.enableFields(fieldName);
    },
    disableButtons: (fieldName: Array<string>) => {
      dynamicFormRef?.current?.disableButtons(fieldName);
    },
    enableButtons: (fieldName: Array<string>) => {
      dynamicFormRef?.current?.enableButtons(fieldName);
    },
    UpdateFieldMandatoryRule: (fieldName: string, flag: boolean) => {
      dynamicFormRef?.current?.UpdateFieldMandatoryRule(fieldName, flag);
    },
    UpdateMultipleFieldMandatoryRule: (
      fieldsArray: Array<{ fieldName: string; value: boolean }>,
    ) => {
      dynamicFormRef?.current?.UpdateMultipleFieldMandatoryRule(fieldsArray);
    },
    setFieldVisibility: (updates: { fieldName: string; updates: any }[]) => {
      dynamicFormRef?.current?.setFieldVisibility(updates);
    },
    setMaskedValue: (fieldName: any, value: any) => {
      dynamicFormRef?.current?.setMaskedValue(fieldName, value);
    },
    CustomMultiFieldsConfiguration: (
      disablefieldName: Array<string>,
      enablefieldName: Array<string>,
      hidefieldName: Array<string>,
      showfieldName: Array<string>,
    ) => {
      dynamicFormRef?.current?.CustomMultiFieldsConfiguration(
        disablefieldName,
        enablefieldName,
        hidefieldName,
        showfieldName,
      );
    },
    disableTabs: (tabNames: string[]) => {
      setFormData((prev: any) => ({
        ...prev,
        data: prev.data.map((tab: any) => ({
          ...tab,
          disabled: tabNames.includes(tab.TabName),
        })),
      }));
    },
    enableTabs: (tabNames: string[]) => {
      setFormData((prev: any) => ({
        ...prev,
        data: prev.data.map((tab: any) => ({
          ...tab,
          disabled: tabNames.includes(tab.TabName) ? false : tab.disabled,
        })),
      }));
    },

    setNextTabAsActive1: () => {
      if (!formData || !activeTabId) return;

      const tabs = formData.data;
      const currentIndex = tabs.findIndex(
        (x: any) => x.TabId.toString() === activeTabId.toString(),
      );

      // 🚫 Already last tab → stop
      if (currentIndex === formData.data.length - 1) return;

      // Find the next enabled tab
      for (let i = currentIndex + 1; i < tabs.length; i++) {
        const tab = tabs[i];

        if (!tab.disabled && tab.AdditionalDetails?.OnLoad === true) {
          setActiveTabId(tab.TabId.toString());
          setActiveTab(i.toString());
          return;
        }
      }

      // const nextIndex = currentIndex + 1;
      // const nextTab = formData.data[nextIndex];

      // setActiveTabId(nextTab.TabId.toString());
      // setActiveTab(nextIndex.toString());

      return;
    },
    setPrevTabAsActive: () => {
      if (!formData || !activeTabId) return;

      const tabs = formData.data;

      const currentIndex = tabs.findIndex(
        (x: any) => x.TabId.toString() === activeTabId.toString(),
      );

      // search backward for previous ACTIVE tab
      for (let i = currentIndex - 1; i >= 0; i--) {
        const tab = tabs[i];

        if (!tab.disabled && tab.AdditionalDetails?.OnLoad === true) {
          setActiveTabId(tab.TabId.toString());
          setActiveTab(i.toString());
          return;
        }
      }

      // 🚫 Already first tab → stop
      if (currentIndex === 0) return;

      // const prevIndex = currentIndex - 1;
      // const prevTab = formData.data[prevIndex];

      // setActiveTabId(prevTab.TabId.toString());
      // setActiveTab(prevIndex.toString());

      return;
    },

    showOnlyTab: (tabName: string) => {
      setFormData((prev: any) => {
        const filteredTabs = prev.data.filter(
          (tab: any) => tab.TabName === tabName,
        );

        if (filteredTabs.length === 0) return prev;

        // Activate that tab
        setActiveTab("0");
        setActiveTabId(filteredTabs[0].TabId.toString());

        return {
          ...prev,
          data: filteredTabs,
        };
      });
    },
    setActiveTabByName: (tabName: string) => {
      if (!formData?.data) return;

      const index = formData.data.findIndex((t: any) => t.TabName === tabName);

      if (index !== -1) {
        setActiveTab(index.toString());
        setActiveTabId(formData.data[index].TabId.toString());
      }
    },
    isFirstTab: () => {
      if (!formData || !activeTabId) return true;

      return (
        formData.data.findIndex(
          (x: any) => x.TabId.toString() === activeTabId.toString(),
        ) === 0
      );
    },
    isLastTab: () => {
      if (!formData || !activeTabId) return true;

      return (
        formData.data.findIndex(
          (x: any) => x.TabId.toString() === activeTabId.toString(),
        ) ===
        formData.data.length - 1
      );
    },
  }));

  // Get config from backend
  const getFormTabsConfig = async () => {
    try {
      showLoader();

      let formTabs = await API.post(getDynamicFormTabs, {
        InterfaceId: interfaceId,
        Mode: props?.Mode ?? state?.Mode,
        RoleId: parseInt(commonContextParams.roleId),
      });

      let dynamicFormData;
      let tempDefaultActiveTab = 0;
      if (formTabs && formTabs.data?.data?.length > 0) {
        dynamicFormData = formTabs.data;
        let defaultActiveTab = formTabs.data.data.find(
          (x: { AdditionalDetails: { IsDefault: boolean } }) =>
            x.AdditionalDetails?.IsDefault === true,
        );

        let defaultOnLoadTab = formTabs.data.data.find(
          (x: { AdditionalDetails: { OnLoad: boolean } }) =>
            x.AdditionalDetails?.OnLoad === true,
        );

        if (defaultActiveTab) {
          tempDefaultActiveTab = defaultActiveTab.TabId.toString();
        } else if (defaultOnLoadTab) {
          tempDefaultActiveTab = defaultOnLoadTab.TabId.toString();
        } else {
          tempDefaultActiveTab = formTabs.data.data[0]?.TabId.toString();
        }

        let defaultActiveTabIndex = defaultActiveTab
          ? formTabs.data.data.findIndex(
              (x: { TabId: number }) =>
                x.TabId.toString() === tempDefaultActiveTab.toString(),
            )
          : 0;

        setActiveTabId(tempDefaultActiveTab);
        setActiveTab(defaultActiveTabIndex.toString());
        setAccessDenied(false);
      } else {
        let message = formTabs.data?.message;
        if (message === "Unauthorized") {
          setAccessDenied(true);
        } else {
          setAccessDenied(false);
        }
        dynamicFormData = null;
        setActiveTabId(0);
        setActiveTab(null);
      }

      setFormData(dynamicFormData);
    } catch (error) {
      hideLoader();
      console.warn(error);
    } finally {
      hideLoader();
    }
  };

  const getKeyLength = (obj?: any, targetKey?: string): number => {
    // NOSONAR : ignore
    if (!obj || typeof obj !== "object") return 0;

    if (targetKey) {
      if (targetKey in obj) {
        const value = obj[targetKey];

        if (typeof value === "string") return value.length;
        if (Array.isArray(value)) return value.length;
        if (typeof value === "object") return Object.keys(value).length;
      }

      for (const value of Object.values(obj)) {
        const length = getKeyLength(value, targetKey);
        if (length !== null) return length;
      }
    }

    return 0;
  };

  const handleTabChange = async (key: any) => {
    setActiveTabId(formData.data[parseInt(key)].TabId);
    setActiveTab(key.toString());
  };

  const validateMessages = {
    required: "'${label}' is required",
  };
  // console.log("formData.data", formData?.data);

  return accessDenied ? (
    <AccessDenied />
  ) : (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          {!props?.hideTitle && (
            <div className="pageName">
              <Title level={4}>
                {(props?.InterfaceName || state?.InterfaceName) ===
                "Request Details Interface"
                  ? "Request Details"
                  : props?.InterfaceName || state?.InterfaceName}{" "}
                {props.subTitle}
              </Title>
            </div>
          )}
        </div>
        <div className="col-lg-12 mt-3">
          <div className="form-container">
            {" "}
            {interfaceId != null && interfaceId != 0 && (
              <Form
                form={form}
                layout="vertical"
                validateMessages={validateMessages}
              >
                {formData?.data?.some(
                  (tab: { TabId: any }) =>
                    tab.TabId && tab.TabId.toString() !== "0",
                ) ? (
                  <Tabs activeKey={activeTab} onChange={handleTabChange}>
                    {formData.data.map((tab: any, index: number) =>
                      (tab?.AdditionalDetails?.IsDefault ||
                        tab?.AdditionalDetails?.OnLoad === true) &&
                      tab?.Permissions?.length > 0 ? (
                        // <TabPane tab={tab.TabName} key={index.toString()}>
                        <TabPane
                          tab={tab.TabName}
                          key={index.toString()}
                          disabled={tab.disabled}
                        >
                          {tab?.AdditionalDetails?.ContentType ===
                          "dashboard" ? (
                            <DynamicMaster
                              InterfaceName={
                                tab?.AdditionalDetails?.InterfaceName
                              }
                              DashboardName={tab?.AdditionalDetails?.ReportName}
                              hideTitle={true}

                              ////Hetal Code
                              // InnerInterfaceName={
                              //   tab?.AdditionalDetails?.InterfaceName
                              // }
                              // InnerDashboardName={
                              //   tab?.AdditionalDetails?.ReportName
                              // }
                              // LoadInnerInterface={props?.LoadInnerInterface}
                            />
                          ) : (
                            <DynamicFormComponent
                              activeTab={activeTabId}
                              form={form}
                              id={interfaceId}
                              actionType={actionType}
                              RId={RId}
                              handleCancel={props?.handleCancel}
                              Mode={props?.Mode ?? state?.Mode}
                              ref={dynamicFormRef}
                              //onFormReady={props.onFormReady}
                            />
                          )}
                        </TabPane>
                      ) : null,
                    )}
                  </Tabs>
                ) : (
                  <DynamicFormComponent
                    id={interfaceId}
                    activeTab={null}
                    form={form}
                    actionType={actionType}
                    RId={RId}
                    handleCancel={props?.handleCancel}
                    Mode={props?.Mode ?? state?.Mode}
                    ref={dynamicFormRef}
                    onSuccess={props.onSuccess}
                    //onFormReady={props.onFormReady}
                  />
                )}
              </Form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default InterfaceComponent;
